import React, { useRef, useState } from 'react';
import { Button, Typography } from 'ui-kit';
import Stack from 'ui-kit/Stack';
import { useAnalytics } from 'analytics';

import videoFile from './onboarding.mp4';
import posterFile from './poster.png';
import './styles.scss';

interface IProps {
  onNext: () => void;
}

const OnboardingVideo = ({ onNext }: IProps) => {
  const [isPlaying, setIsPlaying] = useState(false);
  const videoRef = useRef(null);
  const capture = useAnalytics();
  // Both fire again on resume / rewatch; we only want the first.
  const hasCapturedPlay = useRef(false);
  const hasCapturedCompletion = useRef(false);

  const handleStartedPlaying = () => {
    setIsPlaying(true);
    if (hasCapturedPlay.current) {
      return;
    }
    hasCapturedPlay.current = true;
    capture('onboarding_video_played', {});
  };

  const handleFinishedPlaying = () => {
    if (hasCapturedCompletion.current) {
      return;
    }
    hasCapturedCompletion.current = true;
    capture('onboarding_video_completed', {});
  };

  const handlePlay = () => {
    videoRef.current.play();
    setIsPlaying(true);
  };

  return (
    <Stack
      flexDirection="column"
      className="OnboardingVideo"
      gap="1rem"
      justifyContent="center"
      alignItems="center"
    >
      <Typography variant="h4" className="OnboardingVideo__title" color="primary">
        Welcome to The Host Co
      </Typography>
      <Typography variant="body1" className="OnboardingVideo__description" color="primary">
        See how a digital storefront adds revenue and instantly upgrades your guest experience.
      </Typography>
      <div className="OnboardingVideo__video-container">
        <video
          controls={isPlaying}
          ref={videoRef}
          poster={posterFile}
          className="OnboardingVideo__video"
          onPlay={handleStartedPlaying}
          onPause={() => setIsPlaying(false)}
          onEnded={handleFinishedPlaying}
        >
          <source src={videoFile} type="video/mp4" />
        </video>

        {/* Play Button Overlay */}
        {!isPlaying && (
          <button onClick={handlePlay} className="OnboardingVideo__play-button">
            <svg style={{ width: '44px', height: '44px', color: 'white' }} viewBox="0 0 24 24">
              <path d="M8 5v14l11-7z" />
            </svg>
          </button>
        )}
      </div>
      <Button onClick={onNext} variant="contained">
        Next
      </Button>
    </Stack>
  );
};

export default OnboardingVideo;
